import React, { useEffect, useState } from 'react';
import api from '../services/api';

interface Banner {
  id: number;
  title: string | null;
  image_url: string | null;
  url: string | null;
  position: string;
}

// كاش بسيط على مستوى الجلسة حتى لا يتكرر طلب /banners لكل موضع في الصفحة
let _cache: Banner[] | null = null;
let _pending: Promise<Banner[]> | null = null;

async function loadBanners(): Promise<Banner[]> {
  if (_cache) return _cache;
  if (_pending) return _pending;
  _pending = api
    .get('/banners')
    .then((res) => {
      const raw = res?.data?.data ?? res?.data ?? [];
      _cache = Array.isArray(raw) ? (raw as Banner[]) : [];
      return _cache;
    })
    .catch(() => {
      _cache = [];
      return _cache;
    })
    .finally(() => {
      _pending = null;
    });
  return _pending;
}

interface Props {
  position: string;
  className?: string;
}

const BannerSlot: React.FC<Props> = ({ position, className }) => {
  const [banners, setBanners] = useState<Banner[]>([]);

  useEffect(() => {
    let alive = true;
    loadBanners().then((all) => {
      if (alive) {
        setBanners(all.filter((b) => b.position === position && b.image_url));
      }
    });
    return () => {
      alive = false;
    };
  }, [position]);

  if (banners.length === 0) return null;

  return (
    <div
      className={className}
      style={{ display: 'flex', flexDirection: 'column', gap: 10, margin: '14px 0' }}
    >
      {banners.map((b) => {
        const img = (
          <img
            src={b.image_url as string}
            alt={b.title || 'إعلان'}
            loading="lazy"
            style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }}
          />
        );
        return (
          <div
            key={b.id}
            style={{
              borderRadius: 12,
              overflow: 'hidden',
              boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
              border: '1px solid #ECECEC',
              background: '#fff',
            }}
          >
            {b.url && /^https?:\/\//i.test(b.url) ? (
              <a href={b.url} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
                {img}
              </a>
            ) : (
              img
            )}
          </div>
        );
      })}
    </div>
  );
};

export default BannerSlot;
